export default Object.freeze({
    PENDING: 'NV',
    VALIDATED: 'VALID',
    MATCH_NOT_FOUND: 'NOTVALID',
    MANUAL: 'MANUAL'
})
